const basicInformation = {
  en: {
    translation: {
      popup_change_first_category_title: "Main category",
      popup_change_first_category_text:
        "This is your main category! Go to 'Check-in parameteres' to modify it.",
      tooltip_checkin:
        "Check-in duration changes according to the main category",
      edit_first_info: "General info",
      add_email: "Add email",
      add_phone: "Add phone",
      edit_address: "Edit address",
      pin_label: "Drag me in the right position",
      search_by_address: "Search by address",
      update_address: "Update address",
      fix_data_title: "Ops!",
      fix_data:
        "Some fields have not been filled in, make sure you have entered all the required information.",
      checkin_parameters: "Check-in parameters",
      checkin_time: "Check-in time",
      checkin_range: "Check-in range",
      edit_price: "Price range",
      edit_categories: "Additional categories",
      edit_ideal_for: "Edit ideal for",
      main_phone: "Your certified contact number is",
      main_phone_edit:
        "If you would like to modify it contact us at support@foodiestrip.com or call us at +39 02 9443 2416",
      service_not_paid_title: "Manage check-in",
      service_not_paid_text:
        "Manage the check-in parameters of your business with our plans! Discover all the services included in the 'Essential, Essential plus and Premium' plans in the dedicated area.",
      alias_description:
        "The alias is the string displayed on the URL when people search for your business. It is unique and it is composed of the name and the address of the business. It represents a crucial aspect of your positioning. In case you should find any discrepancies or inaccuracy you can modify it requesting a change. Please don't use bad language, use only lowercase letters, numbers and the hyphen “-”.",
      request_change_alias: "Change Alias",
      change_alias: "Change Alias",
      alias: "Alias",
      request_send: "Request submitted",
      validating_request:
        "Your request has been successfully submitted, our team will verify the new alias before approving it.",
      request_error_title: "Oops!",
      error_insert_alias: "*error inserting new alias",
      error_duplicate_alias:
        "*error, the alias you chose is already taken, contact us at support@foodiestrip.com or call at +39 02 9443 2416",
      error_pattern_alias: "*error, that kind of alias is not possible",
      already_requested: "Please, wait a moment while we process your request",
      map_type_satellite: "satellite",
      map_type_advanced: "advanced",
      map_type_normal: "standard",
      map_type_yellow: "detailed",
      one_stars: "one star",
      two_stars: "two stars",
      three_stars: "three stars",
      four_stars: "four stars",
      five_stars: "five stars",
      five_s_stars: "five stars superior",
      stars_placeholder: "choose star rating",
      stars_label: "Your stars"
    }
  },
  it: {
    translation: {
      popup_change_first_category_title: "Categoria principale",
      popup_change_first_category_text:
        "Questa è la tua categoria primaria! Per modificarla vai alla sezione 'Parametri check-in'.",
      tooltip_checkin:
        "La durata del check-in cambia in base alla categoria principale",
      edit_first_info: "Informazioni generali",
      add_email: "Aggiungi email",
      add_phone: "Aggiungi telefono",
      edit_address: "Modifica indirizzo",
      pin_label: "Spostami nella posizione corretta",
      search_by_address: "Cerca dall'indirizzo",
      update_address: "Aggiorna indirizzo",
      fix_data_title: "Ops!",
      fix_data:
        "Alcuni campi non sono stati compilati, assicurati di aver inserito tutte le informazioni richieste.",
      checkin_parameters: "Parametri check-in",
      checkin_time: "Tempo di check-in",
      checkin_range: "Check-in range",
      edit_price: "Fascia di prezzo",
      edit_categories: "Altre categorie",
      edit_ideal_for: "Modifica ideale per",
      main_phone: "Il numero di telefono certificato è",
      main_phone_edit:
        "* per modificarlo contattaci a support@foodiestrip.com o al numero +39 02 9443 2416",
      service_not_paid_title: "Gestione check-in",
      service_not_paid_text:
        "La gestione completa dei parametri del check-in è inclusa nei pacchetti 'Essential, Essential plus e Premium'. Scopri i nostri servizi nella sezione dedicata.",
      alias_description:
        "L'alias è la stringa mostrata nella barra dell'URL quando qualcuno ricerca la tua struttura. È univoco ed è composto dal nome dell'attività e dal suo indirizzo. Definisce dunque un aspetto essenziale per il tuo posizionamento. In caso di incongruenze o imprecisioni nella stringa avete la possibilità di modificarlo, richiedendone il cambio. Per favore non essere volgare e usa solo lettere minuscole, numeri e il trattino “-” .",
      request_change_alias: "Richiedi cambio",
      change_alias: "Cambio Alias",
      alias: "Alias",
      request_send: "Richiesta inviata",
      validating_request:
        "La tua modifica è stata presa in carico, il nostro team verificherà il nuovo alias prima di approvarlo.",
      request_error_title: "Ops!",
      error_insert_alias: "*errore inserimento nuovo alias",
      error_duplicate_alias:
        "*errore, l'alias che hai scelto è già occupato, contattaci a support@foodiestrip.com o al numero +39 02 9443 2416",
      error_pattern_alias:
        "*errore, non è possibile inserire quel tipo di alias",
      already_requested:
        "Per favore, aspetta un momento mentre la tua richiesta viene processata",
      map_type_satellite: "satellitare",
      map_type_advanced: "avanzata",
      map_type_normal: "standard",
      map_type_yellow: "dettagliata",
      one_stars: "una stella",
      two_stars: "due stelle",
      three_stars: "tre stelle",
      four_stars: "quattro stelle",
      five_stars: "cinque stelle",
      five_s_stars: "cinque stelle lusso",
      stars_placeholder: "seleziona classificazione",
      stars_label: "Le tue stelle"
    }
  }
};

export default basicInformation;
